import { Box, Button, styled, Typography } from '@mui/material';
import { getPlatformLabel, getPolicyLabel } from './columns';

const DetailsContainer = styled(Box)`
  margin-top: 30px;
  display: flex;
`;

const Details = styled(Box)`
  display: flex;
  flex-direction: column;
`;

const DetailsTitle = styled(Typography)`
  color: #181818;

  font-size: 16px;
  font-style: normal;
  font-weight: 700;
`;

const DetailsValue = styled(Typography)`
  color: #181818;

  font-size: 16px;
  font-style: normal;
  font-weight: 400;
`;

const StyledTypography = styled(Typography)`
  color: #807f83;

  font-size: 16px;
  font-style: normal;
  font-weight: 400;
`;

const DeleteButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.error.main,
  padding: '18px 20px',
  borderRadius: 20,
  color: '#FFF',
  marginTop: '60px',
  '&:hover': { backgroundColor: theme.palette.error.main },
}));

interface IProps {
  version: {
    platform: number;
    versionTag: string;
    policyType: number;
    createdAt?: Date;
  };
  onDelete: () => void;
}

export function DeleteAppVersionContainer({ version, onDelete }: IProps) {
  return (
    <Box>
      <StyledTypography>
        You are going to delete this version permanently, are you sure about it?
      </StyledTypography>
      <DetailsContainer>
        <Details>
          <DetailsTitle>App Platform</DetailsTitle>
          <DetailsValue>{getPlatformLabel(version.platform)}</DetailsValue>
        </Details>
        <Details sx={{ ml: '60px' }}>
          <DetailsTitle>App Version</DetailsTitle>
          <DetailsValue>{version.versionTag}</DetailsValue>
        </Details>
        <Details sx={{ ml: '60px' }}>
          <DetailsTitle>Policy Type</DetailsTitle>
          <DetailsValue>{getPolicyLabel(version.policyType)}</DetailsValue>
        </Details>
        <Details sx={{ ml: '60px' }}>
          <DetailsTitle>Created At</DetailsTitle>
          <DetailsValue> {version.createdAt ? new Date(version.createdAt).toLocaleDateString(): 'N/A'}</DetailsValue>
        </Details>
      </DetailsContainer>
      <DeleteButton fullWidth onClick={onDelete}>
        Delete
      </DeleteButton>
    </Box>
  );
}
